// import { AiFillThunderbolt } from "react-icons/ai";

function Footer() {
  return (
    <>
      <footer className="text-center text-white bg-neutral-900">
        <div className="p-4 text-center xs:grid sm:flex sm:flex-row sm:justify-center gap-1" style={{ backgroundColor: "black" }}>
          <div>
            © 2024 Copyright {"    "}
            <a className="text-whitehite" href="/">
              <span className="font-semibold">Product</span>{" "}
              <span className="font-semibold text-blue-700">Library</span>
            </a>
          </div>
          {/* <span className="sm:block hidden mt-1"><AiFillThunderbolt size={20} color="yellow"/></span>
          <div>  
            <span className="font-semibold">Powered By</span>{" "}
            <a className="text-whitehite" href="/">
              <span className="bg-gradient-to-r from-danger to-primary bg-clip-text text-transparent font-bold uppercase">Neo - IT</span>
            </a>
          </div> */}
        </div>
      </footer>
    </>
  );
}

export default Footer;
